import { X } from "lucide-react";
import { useContext } from "react";
import { LeadsContext } from "../../context/LeadsContext";

export default function ModalPurchaseLead() {


  const { isOpenModalPurchases, setIsOpenModalPurchases } = useContext(LeadsContext);
  const { purchasesLead, setPurchasesLead } = useContext(LeadsContext); //Estado que armazena as compras da Lead



  if (!isOpenModalPurchases) return null;

  // return (
  //   <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
  //     <div className="bg-surface-1 border border-white/[0.08] rounded-xl p-6 max-w-2xl w-full">
  //       <div className="flex justify-between items-center mb-4">
  //         <h2 className="text-xl font-bold">Compras de {purchasesLead.nome}</h2>
  //         <button onClick={() => {setIsOpenModalPurchases(false); setPurchasesLead(null)}}><X className="text-white" /></button>
  //       </div>
  //       {purchasesLead.compras && purchasesLead.compras.length > 0 ? (
  //         <table className="w-full text-sm border border-white/[0.08]">
  //           <thead className="bg-surface-3">
  //             <tr>
  //               <th className="p-2 text-left">Produto</th>
  //               <th className="p-2 text-left">Data</th>
  //               <th className="p-2 text-left">Valor Produtor</th>
  //               <th className="p-2 text-left">Valor Produto</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             {purchasesLead.compras.map((v, i) => (
  //               <tr key={i} className="border-t border-white/[0.08]">
  //                 <td className="p-2">{v.produto}</td>
  //                 <td className="p-2">{new Date(v.data_venda).toLocaleString()}</td>
  //                 <td className="p-2">R$ {v.preco_unitario}</td>
  //                 <td className="p-2">R$ {v.valor}</td>
  //               </tr>
  //             ))}
  //           </tbody>
  //         </table>
  //       ) : (
  //         <p className="text-sm text-ink-3">Nenhuma compra registrada para este lead.</p>
  //       )}
  //       <div className="text-right mt-4">
  //         <button onClick={() => {setIsOpenModalPurchases(false); setPurchasesLead(null)}} className="px-4 py-2 bg-surface-3 hover:bg-surface-4 rounded">Fechar</button>
  //       </div>
  //     </div>
  //   </div>
  // );




  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-surface-1 border border-white/[0.08] rounded-xl p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Compras de {purchasesLead.nome}</h2>
          <button onClick={() => { setIsOpenModalPurchases(false); setPurchasesLead(null) }}>
            <X className="text-white" />
          </button>
        </div>

        {purchasesLead.transacoes && purchasesLead.transacoes.length > 0 ? (
          purchasesLead.transacoes.map((transacao, idx) => (
            <div key={idx} className="mb-6 border border-white/[0.08] rounded p-4">
              <div className="mb-2">
                <p className="text-sm text-ink-2">
                  <span className="font-semibold">Plataforma:</span> {transacao.plataforma}
                </p>
                <p className="text-sm text-ink-2">
                  <span className="font-semibold">ID Transação:</span> {transacao.transacao || 'Sem ID'}
                </p>
                {/* <p className="text-sm text-ink-3">
                <span className="font-semibold">Iniciada em:</span> {transacao.inicio_transacao ? new Date(transacao.inicio_transacao).toLocaleString() : '---'}
              </p> */}
              </div>
              {transacao.leads.length > 0 ? (
                <table className="w-full text-sm border border-white/[0.08] mb-2">
                  <thead className="bg-surface-3">
                    <tr>
                      <th className="p-2 text-left">Evento</th>
                      <th className="p-2 text-left">Produto</th>
                      <th className="p-2 text-left">Data</th>
                      <th className="p-2 text-left">Valor Produto</th>
                      <th className="p-2 text-left">Valor Produtor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transacao.leads.map((v, i) => (
                      <tr key={i} className="border-t border-white/[0.08]">
                        <td className="p-2">{v.tipo_evento}</td>
                        <td className="p-2">{v.nome_produto}</td>
                        <td className="p-2">{new Date(v.data_criacao).toLocaleString()}</td>
                        <td className="p-2">R$ {v.valor}</td>
                        <td className="p-2">R$ {v.valor_produtor}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="text-sm text-ink-3">Nenhum evento nesta transação.</p>
              )}
            </div>
          ))
        ) : (
          <p className="text-sm text-ink-3">Nenhuma transação registrada para este lead.</p>
        )}

        {purchasesLead.leads_soltase && purchasesLead.leads_soltase.length > 0 && (
          <div className="mt-6">
            <h3 className="text-md font-semibold text-white mb-2">Eventos sem transação</h3>
            <table className="w-full text-sm border border-white/[0.08]">
              <thead className="bg-surface-3">
                <tr>
                  <th className="p-2 text-left">Evento</th>
                  <th className="p-2 text-left">Produto</th>
                  <th className="p-2 text-left">Data</th>
                  <th className="p-2 text-left">Valor Produto</th>
                  <th className="p-2 text-left">Valor Produtor</th>
                </tr>
              </thead>
              <tbody>
                {purchasesLead.leads_soltase.map((v, i) => (
                  <tr key={i} className="border-t border-white/[0.08]">
                    <td className="p-2">{v.tipo_evento}</td>
                    <td className="p-2">{v.nome_produto}</td>
                    <td className="p-2">{new Date(v.data_criacao).toLocaleString()}</td>
                    <td className="p-2">R$ {v.valor}</td>
                    <td className="p-2">R$ {v.valor_produtor}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="text-right mt-6">
          <button onClick={() => { setIsOpenModalPurchases(false); setPurchasesLead(null) }} className="px-4 py-2 bg-surface-3 hover:bg-surface-4 rounded">
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
